module.exports = __webpack_public_path__ + "img/lego.5a56afc2.svg";